/**
 * @ Author: DY
 * @ Date: 2023-07-14 14:31:38
 * @ LastEditTime: 2024-09-06 14:11:18
 * @ Description:
 * @ FilePath: \ShiMo_Mobile\src\assets\js\charts\index.js
 */
import * as echarts from 'echarts';
import NP from 'number-precision';

let pieChartParameter = null;
let drawLineChart = null;
let lineBarChartParameter = null;
// 基础柱图
let barChartParameter;

// 饼图、嵌套饼图
export function pieChart(obj, parameter) {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    const colors = [
        '#ED6967', '#CDA74D', '#EDA94D', '#967849', '#6D6B7B',
        '#7585A2', '#DC875D', '#CE5478', '#5D5695', '#8C9B59',
        '#A46E4B', '#CD5050', '#51867F', '#745A5A', '#8C517D',
        '#547796', '#7C5446', '#A1504A',
    ];
    if (pieChartParameter !== null) {
        pieChartParameter.dispose();
    }
    pieChartParameter = echarts.init(newObj);

    const newOption = {
        title: {
            text: parameter.chartTitle,
            top: parameter.titlePosition ? parameter.titlePosition[0] : 'center',
            left: parameter.titlePosition ? parameter.titlePosition[1] : 'center',
            textStyle: parameter.textStyle ? parameter.textStyle : {
                fontSize: 14,
                color: '#666666',
                fontWeight: 'bold',
            },
            subtext: parameter.chartSubtext,
            subtextStyle: parameter.chartSubtextStyle ? parameter.chartSubtextStyle : {
                color: '#666666',
                fontSize: 12,
            },
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b}：<br/>{c} ({d}%)',
        },
        legend: {
            show: false,
        },
        series: [{
            type: 'pie',
            radius: ['40%', '60%'],
            center: ['center', 'center'],
            selectedMode: 'single',
            color: colors,
            top: 70,
            itemStyle: {
                borderWidth: 2,
            },
            label: {
                alignTo: 'edge',
                formatter: '{name|{b}} \n{value|{c}}',
                minMargin: 5,
                edgeDistance: 20,
                lineHeight: 18,
                rich: {
                    name: {
                        fontSize: 11,
                        color: '#666',
                    },
                    value: {
                        fontSize: 11,
                        color: '#666',
                    },
                },
            },
            labelLine: {
                length: 10,
                length2: 10,
            },
            labelLayout: function (params) {
                const isLeft = params.labelRect.x < pieChartParameter.getWidth() / 3;
                const points = params.labelLinePoints;
                let returnData = null;
                if (points) {
                    points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                    returnData = {
                        labelLinePoints: points,
                    };
                }
                return returnData;
            },
            data: [],
        }],
    };
    (parameter.series || []).forEach((item, index) => {
        newOption.series[index] = Object.assign({ type: 'pie' }, newOption.series[index], item);
    });
    pieChartParameter.setOption(newOption, true);
}

// 折线图
// eslint-disable-next-line complexity
export function lineChart(value, data) {
    if (drawLineChart !== null) {
        drawLineChart.dispose();
    }
    drawLineChart = echarts.init(document.getElementById(value));
    const newOption = {
        title: {
            text: '',
            top: 0,
            left: 0,
            textStyle: {
                fontSize: 14,
                color: '#666666',
                fontWeight: 'bold',
            },
            subtext: '',
            subtextStyle: {
                color: '#666666',
                fontSize: 12,
            },
        },
        tooltip: data.tooltip ?? {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        legend: {
            show: true,
            top: data.legendX ?? 0,
            right: data.legendY ?? 0,
            data: data.legendData || [],
            textStyle: {
                color: data.fontColor ?? 'rgba(255,255,255,0.5)',
                fontSize: 12,
            },
            selected: {},
        },
        grid: {
            top: 20,
            left: 10,
            right: 0,
            bottom: 15,
            containLabel: true,
        },
        dataZoom: data.dataZoom ? data.dataZoom : [{
            show: false,
        }],
        xAxis: {
            type: 'category',
            data: data.xdata,
            axisLine: {
                show: true,
                lineStyle: {
                    color: data.borderColor ?? 'rgba(255,255,255,0.1)',
                    type: 'solid',
                    width: 1,
                },
            },
            splitArea: {
                areaStyle: {
                    color: data.fontColor ?? 'rgba(255,255,255,.5)',
                },
            },
            axisLabel: {
                textStyle: {
                    color: data.fontColor ?? 'rgba(255,255,255,0.5)',
                    fontSize: 12,
                },
            },
            splitLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
            boundaryGap: true,
        },
        yAxis: [{
            name: data.yAxisName ?? '',
            min: data.yAxisMin ?? null,
            max: data.yAxisMax ?? null,
            interval: data.yAxisInterval ?? null,
            nameTextStyle: {
                color: data.fontColor ?? 'rgba(255,255,255,0.5)',
                fontSize: 12,
            },
            splitNumber: 5,
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    color: data.borderColor ?? 'rgba(255,255,255,0.1)',
                    type: 'dashed',
                },
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: data.borderColor ?? 'rgba(255,255,255,0.1)',
                },
            },
            axisLabel: {
                show: true,
                textStyle: {
                    color: data.fontColor ?? 'rgba(255,255,255,0.5)',
                },
            },
            axisTick: {
                show: false,
            },
        }],
        series: [],
    };
    data.ydata.forEach(item => {
        newOption.series.push({
            name: item.name,
            type: 'line',
            itemStyle: {
                normal: {
                    label: {
                        show: true,
                        position: item.labelPos ?? 'top',
                        color: item.color[0],
                    },
                    color: item.color[0],
                    lineStyle: !item.isColor ? {
                        color: item.color[0],
                        width: 1,
                    } : null,
                    areaStyle: !item.isColor ? {
                        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                            offset: 0,
                            color: item.color[1],
                        }, {
                            offset: 1,
                            color: item.color[2],
                        }]),
                    } : null,
                },
            },
            areaStyle: !item.isColor ? {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: item.color[1],
                    },
                    {
                        offset: 1,
                        color: item.color[2],
                    },
                    ], false),
                },
            } : null,
            data: item.data,
            markLine: item.markLine ?? null,
        });
    });

    if (data.title) {
        newOption.title = Object.assign({}, newOption.title, data.title);
    }

    if (data.grid) {
        newOption.grid = Object.assign({}, newOption.grid, data.grid);
    }

    drawLineChart.setOption(newOption, true);
    return drawLineChart;
}

// 折线柱图
export function lineBarChart(obj, value) {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    lineBarChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        grid: {
            top: 20,
            left: 10,
            right: 0,
            bottom: 15,
            containLabel: true,
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
        },
        xAxis: {
            data: value.xdata,
            axisLabel: {
                show: true,
                interval: 0,
                formatter: function (params) {
                    let newParamsName = '';
                    const paramsNameNumber = params.length;
                    const provideNumber = 5;
                    const rowNumber = Math.ceil(
                        paramsNameNumber / provideNumber
                    );
                    if (paramsNameNumber > provideNumber) {
                        for (let p = 0; p < rowNumber; p++) {
                            let tempStr = '';
                            const start = p * provideNumber;
                            const end = start + provideNumber;
                            if (p === rowNumber - 1) {
                                tempStr = params.substring(
                                    start,
                                    paramsNameNumber
                                );
                            } else {
                                tempStr = params.substring(start, end) + '\n';
                            }
                            newParamsName += tempStr;
                        }
                    } else {
                        newParamsName = params;
                    }
                    return newParamsName;
                },
                textStyle: {
                    color: '#979EA7',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                },
            },
            axisTick: {
                // 坐标轴刻度相关设置。
                show: false,
            },
            axisLine: {
                // 坐标轴轴线相关设置
                lineStyle: {
                    color: '#D8D8D8',
                },
            },
            splitLine: {
                // 坐标轴在 grid 区域中的分隔线。
                show: false,
                lineStyle: {
                    color: '#E5E9ED',
                },
            },
        },
        yAxis: [
            {
                name: value.yAxisName[0],
                type: 'value',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        fontSize: 12,
                        color: '#E5E9ED',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
            {
                name: value.yAxisName[1],
                type: 'value',
                position: 'right',
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        fontSize: 12,
                        color: '#E5E9ED',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: true,
                    lineStyle: {
                        color: '#E5E9ED',
                        type: 'dashed',
                    },
                },
            },
        ],
        dataZoom: [
            {
                show: value.xdata.length > 5,
                realtime: true,
                height: 14,
                backgroundColor: '#FBEEEE',
                borderColor: '#EAD9D9',
                fillerColor: '#ED6967',
                borderRadius: 7,
                textStyle: {
                    color: 'rgba(213,241,255,0.6)',
                },
            },
        ],
        series: [],
    };

    if (value.grid) {
        newOption.grid = Object.assign({}, newOption.grid, value.grid);
    }

    value.ydata.forEach(item => {
        if (item.type === 'bar') {
            newOption.series.push({
                name: item.name,
                type: 'bar',
                barMaxWidth: 20,
                itemStyle: {
                    normal: {
                        color: new window.$globalHub.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                            [
                                {
                                    offset: 0,
                                    color: item.color[0],
                                },
                                {
                                    offset: 1,
                                    color: item.color[1],
                                },
                            ]
                        ),
                    },
                },
                data: item.data,
            });
        } else {
            newOption.series.push({
                name: item.name,
                type: 'line',
                yAxisIndex: 1, // 使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
                showAllSymbol: true, // 显示所有图形。
                symbolSize: 4, // 标记的大小
                itemStyle: {
                    // 折线拐点标志的样式
                    color: item.color[0],
                    borderColor: item.color[0],
                    width: 1,
                    shadowColor: item.color[0],
                    shadowBlur: 2,
                },
                data: item.data,
            });
        }
    });
    lineBarChartParameter.setOption(newOption, true);
}

// 基础柱图
export function barChart(obj, value) {
    const newObj = document.getElementById(obj);
    if (!newObj) {
        return;
    }
    barChartParameter = window.$globalHub.$echarts.init(newObj);
    const newOption = {
        animationEasing: 'elasticOut',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                label: {
                    show: true,
                },
            },
        },
        grid: value.grid,
        legend: {
            show: true,
            top: 0,
            right: 0,
            data: value.legendData,
            textStyle: {
                color: '#666666',
                fontSize: 12,
            },
            selectedMode: value.selectedMode,
            selected: value.selected,
        },
        xAxis: [
            {
                type: 'category',
                data: value.xdata,
                axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                    //	margin:15,
                    textStyle: {
                        color: '#979EA7',
                        fontStyle: 'normal',
                        fontFamily: '微软雅黑',
                        fontSize: 12,
                    },
                },
                axisTick: {
                    // 坐标轴刻度相关设置。
                    show: false,
                },
                axisLine: {
                    // 坐标轴轴线相关设置
                    lineStyle: {
                        color: '#D8D8D8',
                    },
                },
                splitLine: {
                    // 坐标轴在 grid 区域中的分隔线。
                    show: false,
                    lineStyle: {
                        color: '#E5E9ED',
                    },
                },
            },
        ],
        yAxis: [{
            name: value.yAxisName[0],
            axisLabel: {
                // 坐标轴刻度标签的相关设置。
                interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                //	margin:15,
                textStyle: {
                    color: '#979EA7',
                    fontStyle: 'normal',
                    fontFamily: '微软雅黑',
                    fontSize: 12,
                },
            },
            axisTick: {
                // 坐标轴刻度相关设置。
                show: true,
            },
            axisLine: {
                show: true,
                // 坐标轴轴线相关设置
                lineStyle: {
                    color: '#D8D8D8',
                },
            },
            splitLine: {
                // 坐标轴在 grid 区域中的分隔线。
                show: true,
                lineStyle: {
                    color: '#E5E9ED',
                    type: 'dashed',
                },
            },
            // max: function (value) {
            //     if (value.max <= 0.1) {
            //         const point = NP.plus(value.max, NP.times(value.max, 0.2));
            //         return point;
            //     }
            // },
        }],
        series: [],
    };

    value.ydata.forEach(item => {
        newOption.series.push({
            name: item.name,
            type: 'bar',
            barMaxWidth: 20,
            itemStyle: {
                normal: {
                    color: new window.$globalHub.$echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                            {
                                offset: 0,
                                color: item.color[0],
                            },
                            {
                                offset: 1,
                                color: item.color[1],
                            },
                        ]
                    ),
                },
            },
            data: item.data,
        });
    });
    barChartParameter.setOption(newOption, true);
}
